module.exports = __webpack_public_path__ + "img/icon-Welcome-Gray.341eeb17.png";